import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faSpinner, faPlus, faPen, faTrash, faCheck, faServer, faTimes, faEye, faEyeSlash,
} from '@fortawesome/free-solid-svg-icons';
import ConfirmationModal from '../ConfirmationModal';
import {
    CONNECTION_PROTOCOLS, CONNECTION_CONTENT_TYPES, CONNECTION_ISBN_TYPES,
    CONNECTION_MODELS, DEFAULT_CONNECTION_PORT, EMPTY_CONNECTION,
} from './constants';

function EditorConexion({ initial, onApply, onCancel }) {
    const [form, setForm] = useState({ ...EMPTY_CONNECTION, ...initial });
    const [verPassword, setVerPassword] = useState(false);

    const set = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

    const cambiarProtocolo = (protocol) => {
        setForm((prev) => ({
            ...prev,
            protocol,
            port: DEFAULT_CONNECTION_PORT[protocol] || prev.port,
        }));
    };

    const passwordRequerida = !form.has_password;

    const valido = form.name.trim() && form.host.trim() && form.user.trim() && (!passwordRequerida || form.password);
    const yaExiste = !!form._id;

    const handleSubmit = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        if (!valido) return;
        onApply({
            _id: form._id || '',
            name: form.name.trim(),
            protocol: form.protocol,
            host: form.host.trim(),
            port: Number(form.port) || DEFAULT_CONNECTION_PORT[form.protocol],
            user: form.user.trim(),
            password: form.password || '',
            has_isbn: form.has_isbn,
            content_type: form.content_type,
            model: form.model,
            has_password: form.has_password,
        });
    };

    return (
        <div className="rounded-3 border border-secondary border-opacity-25 p-3 mb-3 bg-black bg-opacity-25">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="text-white mb-0">{yaExiste ? 'Editar conexión' : 'Nueva conexión'}</h6>
                <button type="button" className="btn btn-sm btn-outline-secondary border-0 text-white-50" onClick={onCancel}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>

            <div className="row g-3">
                <div className="col-md-12">
                    <label className="form-label text-white-50">Nombre *</label>
                    <input
                        type="text"
                        className="form-control bg-dark text-white border-secondary py-2"
                        value={form.name}
                        onChange={(e) => set('name', e.target.value)}
                        placeholder="Ej. Ebook con ISBN - Retail"
                    />
                </div>

                <div className="col-md-3">
                    <label className="form-label text-white-50">Protocolo *</label>
                    <select
                        className="form-select bg-dark text-white border-secondary py-2"
                        value={form.protocol}
                        onChange={(e) => cambiarProtocolo(e.target.value)}
                    >
                        {CONNECTION_PROTOCOLS.map((p) => <option key={p.value} value={p.value}>{p.label}</option>)}
                    </select>
                </div>
                <div className="col-md-6">
                    <label className="form-label text-white-50">Host *</label>
                    <input
                        type="text"
                        className="form-control bg-dark text-white border-secondary py-2"
                        value={form.host}
                        onChange={(e) => set('host', e.target.value)}
                        placeholder="sftp.canal.com"
                    />
                </div>
                <div className="col-md-3">
                    <label className="form-label text-white-50">Puerto *</label>
                    <input
                        type="number"
                        className="form-control bg-dark text-white border-secondary py-2"
                        value={form.port}
                        onChange={(e) => set('port', e.target.value)}
                    />
                </div>

                <div className="col-md-4">
                    <label className="form-label text-white-50">Usuario *</label>
                    <input
                        type="text"
                        className="form-control bg-dark text-white border-secondary py-2"
                        value={form.user}
                        onChange={(e) => set('user', e.target.value)}
                        placeholder="usuario"
                    />
                </div>
                <div className="col-md-8">
                    <label className="form-label text-white-50">
                        Contraseña {passwordRequerida ? '*' : <span className="text-white-50">(vacío = mantener actual)</span>}
                    </label>
                    <div className="input-group">
                        <input
                            type={verPassword ? 'text' : 'password'}
                            className="form-control bg-dark text-white border-secondary py-2"
                            value={form.password}
                            onChange={(e) => set('password', e.target.value)}
                            placeholder="contraseña"
                            autoComplete="new-password"
                        />
                        <button
                            type="button"
                            className="btn btn-outline-secondary border-secondary text-white-50"
                            onClick={() => setVerPassword((v) => !v)}
                            tabIndex={-1}
                            title={verPassword ? 'Ocultar' : 'Mostrar'}
                        >
                            <FontAwesomeIcon icon={verPassword ? faEyeSlash : faEye} />
                        </button>
                    </div>
                </div>

                <div className="col-md-4">
                    <label className="form-label text-white-50">Tipo de contenido *</label>
                    <select
                        className="form-select bg-dark text-white border-secondary py-2"
                        value={form.content_type}
                        onChange={(e) => set('content_type', e.target.value)}
                    >
                        {CONNECTION_CONTENT_TYPES.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
                    </select>
                </div>
                <div className="col-md-4">
                    <label className="form-label text-white-50">ISBN</label>
                    <select
                        className="form-select bg-dark text-white border-secondary py-2"
                        value={form.has_isbn}
                        onChange={(e) => set('has_isbn', e.target.value)}
                    >
                        {CONNECTION_ISBN_TYPES.map((i) => <option key={i.value} value={i.value}>{i.label}</option>)}
                    </select>
                </div>
                <div className="col-md-4">
                    <label className="form-label text-white-50">Modelo</label>
                    <select
                        className="form-select bg-dark text-white border-secondary py-2"
                        value={form.model}
                        onChange={(e) => set('model', e.target.value)}
                    >
                        {CONNECTION_MODELS.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
                    </select>
                </div>
            </div>

            <div className="d-flex justify-content-end mt-3">
                <button type="button" className="btn btn-outline-secondary border-secondary text-white-50 px-3 me-2" onClick={onCancel}>Cancelar</button>
                <button type="button" className="btn btn-primary px-3" onClick={handleSubmit} disabled={!valido}>
                    <FontAwesomeIcon icon={faCheck} className="me-1" /> {yaExiste ? 'Actualizar' : 'Agregar'}
                </button>
            </div>
        </div>
    );
}

function TarjetaConexion({ conexion, index, onEdit, onDelete }) {
    return (
        <div className="rounded-3 border border-secondary border-opacity-25 p-3 mb-2 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2">
                <FontAwesomeIcon icon={faServer} className="text-info" />
                <span className="text-white fw-bold">{conexion.name || '(sin nombre)'}</span>
            </div>
            <div className="d-flex gap-2">
                <button type="button" className="btn btn-outline-secondary border-0 text-white-50" title="Editar conexión" onClick={() => onEdit(index)}>
                    <FontAwesomeIcon icon={faPen} />
                </button>
                <button type="button" className="btn btn-outline-danger border-0" title="Eliminar conexión" onClick={() => onDelete(index)}>
                    <FontAwesomeIcon icon={faTrash} />
                </button>
            </div>
        </div>
    );
}

export function ConnectionChannelForm({ initial, onSubmit, saving, onCancel }) {
    const [connections, setConnections] = useState([]);
    const [editando, setEditando] = useState(null);
    const [confirmar, setConfirmar] = useState(null);

    useEffect(() => {
        const base = (initial && initial.connections) || [];
        setConnections(base.map((c) => ({ ...EMPTY_CONNECTION, ...c })));
        setEditando(null);
    }, [initial]);

    const aplicar = (conn) => {
        setConnections((prev) => {
            if (typeof editando === 'number') {
                return prev.map((c, i) => (i === editando ? { ...c, ...conn } : c));
            }
            return [...prev, conn];
        });
        setEditando(null);
    };

    const eliminar = (index) => {
        setConnections((prev) => prev.filter((_, i) => i !== index));
        setConfirmar(null);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({
            _id: initial && initial._id,
            connections: connections.map((c) => ({
                _id: c._id,
                name: c.name,
                protocol: c.protocol,
                host: c.host,
                port: c.port,
                user: c.user,
                password: c.password || '',
                has_isbn: c.has_isbn,
                content_type: c.content_type,
                model: c.model,
            })),
        });
    };

    const editingConn = typeof editando === 'number' ? connections[editando] : EMPTY_CONNECTION;

    return (
        <form onSubmit={handleSubmit} autoComplete="off">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <span className="text-white-50 small">
                    {connections.length} conexión(es). Puedes tener varias según tipo (con/sin ISBN, ebook/audiolibro, modelo).
                </span>
                {editando === null && (
                    <button type="button" className="btn btn-outline-info btn-sm px-3" onClick={() => setEditando('nuevo')} disabled={saving}>
                        <FontAwesomeIcon icon={faPlus} className="me-1" /> Agregar conexión
                    </button>
                )}
            </div>

            {editando !== null && (
                <EditorConexion
                    initial={editando === 'nuevo' ? EMPTY_CONNECTION : editingConn}
                    onApply={aplicar}
                    onCancel={() => setEditando(null)}
                />
            )}

            {connections.length === 0 && editando === null && (
                <div className="text-center text-white-50 py-5 border border-secondary border-opacity-25 rounded-3">
                    Sin conexiones configuradas.
                </div>
            )}

            {connections.map((conexion, index) => (
                editando === index ? null : (
                    <TarjetaConexion
                        key={conexion._id || `new-${index}`}
                        conexion={conexion}
                        index={index}
                        onEdit={(i) => setEditando(i)}
                        onDelete={(i) => setConfirmar(i)}
                    />
                )
            ))}

            <div className="d-flex justify-content-end mt-4 pt-3 border-top border-secondary border-opacity-25">
                <button type="button" className="btn btn-outline-secondary px-4 me-2" onClick={onCancel} disabled={saving}>Cancelar</button>
                <button type="submit" className="btn btn-success px-4" disabled={saving || editando !== null}>
                    {saving ? <FontAwesomeIcon icon={faSpinner} spin className="me-1" /> : null}
                    Guardar conexiones
                </button>
            </div>

            {typeof confirmar === 'number' && (
                <ConfirmationModal
                    isOpen={confirmar !== null}
                    onClose={() => setConfirmar(null)}
                    onConfirm={() => eliminar(confirmar)}
                    title="Eliminar conexión"
                    message={`¿Eliminar la conexión "${connections[confirmar] && connections[confirmar].name}"? Se quitará al guardar.`}
                    confirmText="Eliminar"
                    type="danger"
                />
            )}
        </form>
    );
}

export default ConnectionChannelForm;
